import { createSlice } from '@reduxjs/toolkit';

// Supported UI languages
export const SUPPORTED_LANGUAGES = ['en', 'es', 'pt'];
export const DEFAULT_LANGUAGE = 'en';

const initialState = {
  language: DEFAULT_LANGUAGE,
};

const i18nSlice = createSlice({
  name: 'i18n',
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      const lang = action.payload;
      // Only accept supported languages; fall back to default
      state.language = SUPPORTED_LANGUAGES.includes(lang) ? lang : DEFAULT_LANGUAGE;
    },
  },
});

export const { setLanguage } = i18nSlice.actions;

export default i18nSlice.reducer;
